var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNotes = function SvgIconNotes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17,
    height: 17,
    xmlSpace: "preserve"
  }, props), _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 17,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAQAAACQTsNJAAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAHdElN RQflBgENFgJH7/X8AAAAo0lEQVRIx2NgGAWjgDBghDH+8zJEM0iQoPMFw1LGz2hi/yf/JxVMgull gpvynmRffMD0DiODA4M4CUa8ZDjA+J8WITzgABEmrAx+JIXJC4bNjL/RxP53kRzFXTC9TCTYTYR3 2Bh8SYziTRjeGR6AEcH8b4snF/9jOMT4mqBp/xsIROjH/3y49CKiWIiALZwMXAS9Q6BQ+sewk/Ek jYJ0FIwQAAASg6JEFd35ZAAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyMS0wNi0wMVQxMzoyMjowMisw MzowMNF2wjMAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjEtMDYtMDFUMTM6MjI6MDIrMDM6MDCgK3qP AAAAAElFTkSuQmCC"
  })));
};
export default SvgIconNotes;